import { render, staticRenderFns } from "./carteamCard.vue?vue&type=template&id=6c0b3c54&scoped=true&"
import script from "./carteamCard.vue?vue&type=script&lang=js&"
export * from "./carteamCard.vue?vue&type=script&lang=js&"
import style0 from "./carteamCard.vue?vue&type=style&index=0&id=6c0b3c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b3c54",
  null
  
)

export default component.exports